/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Menureadingdishes2Inputs */

const en_menureadingdishes2 = /** @type {(inputs: Menureadingdishes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} dishes recognised`)
};

const de_menureadingdishes2 = /** @type {(inputs: Menureadingdishes2Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} Gerichte erkannt`)
};

/**
* | output |
* | --- |
* | "{count} dishes recognised" |
*
* @param {Menureadingdishes2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const menureadingdishes2 = /** @type {((inputs: Menureadingdishes2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Menureadingdishes2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_menureadingdishes2(inputs)
	return de_menureadingdishes2(inputs)
});
export { menureadingdishes2 as "menuReadingDishes" }